import React from 'react';

import Hero from '../components/Hero';
import StrategySection from '../components/StrategySection';
import InvestmentShowcase from '../components/InvestmentShowcase';
import TeamSection from '../components/TeamSection';
import ContactForm from '../components/ContactForm';

const Home = () => {
  React.useEffect(() => {
    // Prevent loading twice
    if (window.__chatWidgetLoaded) return;
    window.__chatWidgetLoaded = true;

    const script = document.createElement("script");
    script.src = process.env.REACT_APP_WIDGET_URL; // must be in public/
    script.setAttribute("data-client-id", process.env.REACT_APP_WIDGET_CLIENT_ID);
    script.setAttribute("data-fe-url", process.env.REACT_APP_FE_URL);
    script.defer = true;
    document.body.appendChild(script);
  }, []);
  return (
    <>
      <Hero />
      <StrategySection />
      <InvestmentShowcase />
      <TeamSection />
      <ContactForm />
    </>
  );
};

export default Home;
